import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const Ctx = createContext(null);

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [advisor, setAdvisor] = useState({ open: false, watch: null, nonce: 0 });
  useEffect(() => {
    api.get("/public/settings").then((r) => setSettings(r.data)).catch(() => setSettings({ whatsapp_number: "351916230822", taxonomies: {}, ai: { enabled: false } }));
  }, []);
  const openAdvisor = useCallback((watch = null) => setAdvisor((a) => ({ open: true, watch, nonce: a.nonce + 1 })), []);
  const closeAdvisor = useCallback(() => setAdvisor((a) => ({ ...a, open: false })), []);
  return <Ctx.Provider value={{ settings, advisor, openAdvisor, closeAdvisor }}>{children}</Ctx.Provider>;
}

export const useSite = () => useContext(Ctx);
